<footer>
	<div class="wrapper has-padding is-taller">
		<img class="footer-img-width" src="assets/BofA-logo.svg" alt="A Bank of America application"/>
		<p>Bank of America N.A. Member FDIC &copy;{{ year }} Bank of America Corporation. All rights reserved.</p>
	</div>
</footer>